export const getDivisionValuesFromFields = (item = {}, divisionFields = []) =>
  divisionFields.map((field) => item[field] || '');

export const getSettlementHeaderIndex = (divisionCount = 0) => 7 + divisionCount;
